import {
  ADMIN_ONBOARDINGS_LOADED,
  ADMIN_ONBOARDINGS_CLEAR,
  ADMIN_ONBOARDING_DETAILS_LOADED,
  ADMIN_ONBOARDING_DETAILS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function adminOnboardingsLoaded(onboardings) {
  return {
    type: ADMIN_ONBOARDINGS_LOADED,
    payload: { onboardings },
  };
}

export function adminOnboardingsClear() {
  return { type: ADMIN_ONBOARDINGS_CLEAR };
}

export function adminOnboardingDetailsLoaded(details) {
  return {
    type: ADMIN_ONBOARDING_DETAILS_LOADED,
    payload: { details },
  };
}

export function adminOnboardingDetailsClear() {
  return { type: ADMIN_ONBOARDING_DETAILS_CLEAR };
}

// --- API functions ---
async function fetchOnboardingsApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'common/customer-onboardings/admin/list',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function fetchOnboardingDetailsApi(token, id, dispatch) {
  const response = await api.get({
    path: `common/customer-onboardings/admin/${id}`,
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

// --- Public component actions ---
export function initiateFetchAdminOnboardings(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const onboardings = await fetchOnboardingsApi(adminToken, params, dispatch);
      dispatch(adminOnboardingsLoaded(onboardings));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearAdminOnboardings() {
  return (dispatch) => {
    dispatch(adminOnboardingsClear());
  };
}

export function initiateFetchAdminOnboardingDetails(id) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const details = await fetchOnboardingDetailsApi(adminToken, id, dispatch);
      dispatch(adminOnboardingDetailsLoaded(details));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearAdminOnboardingDetails() {
  return (dispatch) => {
    dispatch(adminOnboardingDetailsClear());
  };
}
